// 購入ボタンのテキストを変更
document.addEventListener("DOMContentLoaded", function () {
  const parallax = document.querySelector(".js-parallax");
  if (parallax !== null) {
    let target = document.getElementsByClassName("js-parallax");
    new simpleParallax(target, {
      delay: 1,
      orientation: "up",
      scale: 1.1,
    });
  }

  const header = document.querySelector("#header");
  if (header) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        header.classList.add("header__active");
      } else {
        header.classList.remove("header__active");
      }
    });
  }

  const closeButton = document.querySelector('.c-newsbar__close');
  const newsBar = document.querySelector('.c-newsbar');
  
  if (newsBar) {
    closeButton.addEventListener('click', function() {
      newsBar.style.display = 'none';
      header.classList.add('newsbar__close');
    });
  } else {
    header.classList.add('newsbar__close');
  }

  const target = document.querySelector('#products');
  if (target) {
    const parentLi = target.closest('li');
    if (parentLi) {
      parentLi.style.display = 'none';
    }
  }
});